module.exports = __webpack_public_path__ + "media/images/icons/telephone-cb158bbe635a52587b0a3c3b4c140977.svg";